import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react'
import TerminarTrabajoUnidades from './TerminarTrabajoUnidades/TerminarTrabajoUnidades'
import TerminarTrabajoCajas from './TerminarTrabajoCajas/TerminarTrabajoCajas'
import DateUtilities from '../DateUtilities'
import TerminarTrabajoBotes from './TerminarTrabajoBotes/TerminarTrabajoBotes'

class Trabajo extends Component {

	constructor(props) {
		super(props);
		this.trabajo = {
			nombreActividad: props.nombreActividad,
			area: props.area,
			trabajoHecho: props.trabajoHecho,
			unidad: props.unidad,
			dificultad: props.dificultad,
			precioUnitario: props.precioUnitario || 0,
			precio: props.precio,
			empleados: props.empleados,
			trabajoID: props.trabajoID,
			estado: props.estado,
			descripcion: props.descripcion,
			fechaEntrega: props.fechaEntrega || '',
			nomina: props.nomina,
		}
		if (this.trabajo.unidad === 'cajas') {
			this.trabajo = {
				...this.trabajo,
				cajas6Precio: props.cajas6Precio,
			}
		}
		this.state = {
			diasFaltantes: 0
		}
	}
	getDaysDiff = () => {
		if (this.trabajo.fechaEntrega === '')
			return null
		this.setState({
			diasFaltantes: DateUtilities.GetDayDifference(this.trabajo.fechaEntrega.toDate(), DateUtilities.today())
		})
	}
	componentDidMount() {
		this.getDaysDiff()
		var that = this;
		var date = new Date().getDate(); //Current Date
		var month = new Date().getMonth() + 1; //Current Month
		var year = new Date().getFullYear(); //Current Year
		var hours = new Date().getHours(); //Current Hours
		var min = new Date().getMinutes(); //Current Minutes
		that.setState({
			//Setting the value of the date time
			fecha:
				date + '/' + month + '/' + year + ' ' + hours + ':' + min,
		});

		this.contadorDias = this.fechaFin - this.fechaInicio;
	}

	handleTerminarPendiente = (id, personas) => {
		this.props.terminarPendiente(id, personas);
	}

	render() {
		return (
			<>
				<td> {this.trabajo.empleados} </td>
				<td> {this.trabajo.nombreActividad} </td>
				<td> {this.state.diasFaltantes}</td>
				<td> {this.trabajo.descripcion} </td>
				<td> {this.trabajo.area} </td>
				<td> {`${this.trabajo.trabajoHecho} ${this.trabajo.unidad || ''}`} </td>
				<td> ${this.trabajo.precio} </td>
				{
					(() => {
						switch (this.trabajo.unidad) {
							case 'metros':
								return (
									<td>
										<button onClick={() => this.handleTerminarPendiente(this.trabajo)}>
											Completar
										</button>
									</td>
								)
							case 'cajas':
								return (
									<td>
										<Modal trigger={<button>Completar</button>}>
											<Modal.Header>Completar</Modal.Header>
											<Modal.Content>
												{
													<TerminarTrabajoCajas trabajo={this.trabajo} />
												}
											</Modal.Content>
										</Modal>
									</td>
								)
							case 'unidades':
								return (
									<td>
										<Modal trigger={<button>Completar</button>}>
											<Modal.Header>Completar</Modal.Header>
											<Modal.Content>
												{
													<TerminarTrabajoUnidades trabajo={this.trabajo} />
												}
											</Modal.Content>
										</Modal>
									</td>
								)
							case 'botes':
								return(
									<td>
										<Modal trigger={<button>Completar</button>}>
											<Modal.Header>Completar</Modal.Header>
											<Modal.Content>
												{
													<TerminarTrabajoBotes trabajo={this.trabajo} />
												}
											</Modal.Content>
										</Modal>
									</td>
								)
							default:
								return(
									<td>Error</td>
								)
						}
					})()
				}
			</>
		);
	}
}
export default Trabajo